/* Custom positioner - Allows for the tooltip to follow the cursor's pointer
*
* Notes:
* - https://www.chartjs.org/docs/latest/configuration/tooltip.html#custom-position-modes
* - https://codepen.io/AZIIZoom/pen/eYzJNZW?editors=1010
* @function Tooltip.positioners.myCustomPositioner
* @param elements {Chart.Element[]} the tooltip elements
* @param eventPosition {Point} the position of the event in canvas coordinates
* @returns {TooltipPosition} the tooltip position
*/
export function cursorPositioner(elements, eventPosition) {
  // A reference to the tooltip model
  // const tooltip = this;

  /* ... */

  return {
      x: eventPosition.x,
      y: eventPosition.y
  };
}

export function axis_font_opts() {
  let axislabelsFontSize = (window.innerWidth > 700) ? 16 : 14;

  return {
    size: axislabelsFontSize,
    family: "'Luma Sans', 'Helvetica', 'Arial', sans-serif",
    weight: 'bold',
  }
}
